/* @ngInject */
function AssetFolderController (
  $rootScope,
  $scope,
  $translate,
  $q,
  $state,
  Utils,
  UdsModalService,
  NewAssetService,
  RepositoryService,
  ToastService,
  SegmentService
) {
  const getManageAssetsDialogController = () =>
    $q.when(import('../../dialogs/manage-assets/manage-assets-dialog.controller'))
  const getMoveToTrashDialogController = () =>
    $q.when(import('../../dialogs/move-to-trash/move-to-trash-dialog.controller'))
  const getOrganizeAssetDialogController = () =>
    $q.when(import('../../dialogs/organize-asset/organize-asset-dialog.controller'))
  const getShareWithGuestsDialogController = () =>
    $q.when(import('../../../core/dialogs/share-with-guests/share-with-guests-dialog.controller'))

  $scope.folderDefaultThumbnailSrc = '/assets/img/repository_folder_thumbs/default_thumb.png'

  const api = {
    getShareWithGuestsDialogController,
    getManageAssetsDialogController,
    getMoveToTrashDialogController,
    getOrganizeAssetDialogController,
    _handleFolderData,
    _checkShowShareButton
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._handleFolderData()
    api._checkShowShareButton()
  }

  $scope.handleOpenFolder = folder => {
    $scope.openFolder({ folder })
  }

  function _handleFolderData () {
    if ($scope.cardType === 'full' && $scope.folder.thumbnailId) {
      $scope.folderThumbnailSrc = NewAssetService.getAssetThumbnailUrl($scope.folder.thumbnailId, 'LOW')
    }
  }

  function _checkShowShareButton () {
    Promise.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures(),
      $rootScope.getUser()
    ]).then(([{ features }, companyFeatures, user]) => {
      $scope.showShareButton = (features['SHARE.GUEST'] || companyFeatures.includes('GUEST_ASSET_PACK')) && $rootScope.isUserSysAdminAdmin(user)
    })
  }

  const deregisterUpdateFolderName = $rootScope.$on('asset-folder.update-folder-name', (e, folderId, newName) => {
    if ($scope.folder.id === folderId) {
      $scope.folder.title = newName
      api._handleFolderData()
    }
  })

  $scope.$on('$destroy', function () {
    deregisterUpdateFolderName()
  })

  $scope.handleFolderSelection = (event, selectedFolders, folder) => {
    if ($scope.modalState) return

    if ($scope.onClick) {
      $scope.onClick(folder)
    }

    event.stopPropagation()

    const folderIndex = selectedFolders.findIndex(f => f.id === folder.id)
    if (folderIndex !== -1) {
      selectedFolders.splice(folderIndex, 1)
      return
    }

    Utils.toggleItemOnArray(selectedFolders, folder, (a, b) => a.id === b.id)
  }

  $scope.isFolderSelected = (selectedFolders, folder) => {
    selectedFolders = selectedFolders || []
    const foundFolder = selectedFolders.find(selectedFolder => selectedFolder.id === folder.id)

    return Boolean(foundFolder)
  }

  $scope.openShareDialog = () => {
    api.getShareWithGuestsDialogController().then(({ ShareWithGuestsDialogController }) => {
      const shareWithGuestsDialog = UdsModalService.createModal({
        controller: ShareWithGuestsDialogController,
        modalName: 'shareWithGuestsDialog',
        data: {
          itemType: 'assetPack',
          assetPack: [{
            id: $scope.folder.id,
            type: 'folder'
          }],
          packTitle: $scope.folder.title
        }
      })
      shareWithGuestsDialog.open()
    })
  }

  $scope.copyFolderLink = () => {
    const folders = [$scope.folder]

    RepositoryService.copyAssetsFolderUrlsToClipboard(folders)
      .then(() => {
        ToastService.showSuccessToast(
          $translate.instant('assetFolder.toasts.copyLinkBatch.success', { folderName: $scope.folder.title })
        )
      })
      .catch(() => {
        ToastService.showErrorToast(
          $translate.instant('assetFolder.toasts.copyLinkBatch.error', { folderName: $scope.folder.title })
        )
      })
  }

  $scope.downloadFolderAssets = () => {
    const folderId = $scope.folder.id

    if (folderId) {
      RepositoryService.downloadAssetsFolderBatch([folderId], 'REPOSITORY')
        .then(() => {
          ToastService.showSuccessToast($translate.instant('assetFolder.toasts.downloadAssets.success'))
          SegmentService.track('downloaded-file', { folder_id: folderId })
        })
        .catch(() => {
          ToastService.showErrorToast($translate.instant('assetFolder.toasts.downloadAssets.error'))
        })
    }
  }

  $scope.openFolderSettings = tabToOpen => {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          folders: [$scope.folder],
          tabToOpen
        },
        onClose: updatedFolder => {
          if (!updatedFolder) {
            return
          }

          $scope.folder.title = updatedFolder.name
          api._handleFolderData()
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.moveFolderToTrash = folder => {
    const assets = [
      {
        id: folder.id,
        // assetSize: '10MB',
        assetName: folder.title,
        assetIcon: 'dam',
        isFolder: true
      }
    ]

    getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            const assetIndex = $scope.currentSection.assets.findIndex(sectionFolder => sectionFolder.id === folder.id)

            $scope.currentSection.assets.splice(assetIndex, 1)
            $scope.currentSection.totalCount--
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  $scope.restoreFolder = folder => {
    const nameDisplayLength = 32
    const folders = [
      {
        id: folder.id,
        assetName: Utils.truncateText(folder.title, nameDisplayLength),
        isFolder: true
      }
    ]

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets: folders,
          isRestoring: true,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            const folderIndex = $scope.currentSection.assets.findIndex(sectionFolder => sectionFolder.id === folder.id)

            $scope.currentSection.assets.splice(folderIndex, 1)
            $scope.currentSection.totalCount--
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.permanentlyDeleteFolder = () => {}

  $scope.onErrorLoadBackgroundImage = () => {
    $scope.folderThumbnailSrc = $scope.folderDefaultThumbnailSrc
  }

  $scope.organizeFolder = folder => {
    const nameDisplayLength = 32
    const folders = [
      {
        id: folder.id,
        assetName: Utils.truncateText(folder.title, nameDisplayLength),
        parentId: folder.parentId,
        isFolder: true
      }
    ]

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets: folders,
          isRestoring: false,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            const folderIndex = $scope.currentSection.assets.findIndex(sectionFolder => sectionFolder.id === folder.id)

            $scope.currentSection.assets.splice(folderIndex, 1)
            $scope.currentSection.totalCount--
          }
        }
      })

      organizeAssetDialog.open()
    })
  }
}

export { AssetFolderController }
